import { useEffect, useState } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { MapMultipleMarkers } from 'common/widgets'
import classNames from './styles.module.scss'


MapView.propTypes = {
  className: PropTypes.string,
}

export default function MapView({
  className = undefined,
  ...props
}) {
  const [map, setMap] = useState(null)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setMap(<MapMultipleMarkers {...props} />)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [])
  return (
    <div className={cx(classNames.singlePageMap, className)}>
      {map}
    </div>
  )
}
